// src/components/PDFViewer.jsx
import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const PDFViewer = ({ fileUrl, onClose }) => {
  return (
    <div
            className="modal show d-block"
            tabIndex="-1"
             onContextMenu={(e) => e.preventDefault()}
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content"  onContextMenu={(e) => e.preventDefault()}>
                <div className="modal-header">
                  <h5 className="modal-title">View File</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={onClose}
                  ></button>
                </div>
                <div className="modal-body" style={{ height: "80vh" }} onContextMenu={(e) => e.preventDefault()}>

        {/* PDF viewer */}
        <div style={{ height: '100%' }}>
          <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js">
            <Viewer fileUrl={fileUrl} />
          </Worker>
        </div>
      </div>
    </div>
    </div>
    </div>
  );
};

export default PDFViewer;
